import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly apiKey = environment.apiGoogleMapsKey;

  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }

    if (this.loadPromise) return this.loadPromise;

    const win = this.document.defaultView as any;

    if (typeof win?.google?.maps?.importLibrary === 'function') {
      this.loadPromise = Promise.resolve();
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const script = this.document.createElement('script');
      script.src =
        `https://maps.googleapis.com/maps/api/js` +
        `?key=${this.apiKey}` +
        `&loading=async` +
        `&libraries=maps,marker`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Google Maps API could not load.'));
      this.document.head.appendChild(script);
    });

    return this.loadPromise;
  }

  async importLibrary<T = any>(libraryName: string): Promise<T> {
    await this.load();
    const win = this.document.defaultView as any;
    return win.google.maps.importLibrary(libraryName) as Promise<T>;
  }
}